import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './Navbartop.css';
import React, {useContext, useState} from 'react';
import { MadricContext } from '../../Context/MadricContext';

/**
 * La vue de la barre de navigation
 * @param {*} props props
 * @return {JSX}
 */
function NavbartopView(props) {
  const {activeLink, setActiveLink} = useContext(MadricContext);

  // Function to handle click on a nav link
  const handleNavLinkClick = (link) => {
    setActiveLink(link);
  };

  return (
    <Navbar id="navbar" collapseOnSelect expand="md" bg="dark" variant="dark" className="my-navbar ">
      <Container>
        <Navbar.Brand style={{cursor: 'pointer'}} onClick={() => {
          handleNavLinkClick('accueil'); props.navigateAccueil();
        }} className={activeLink === 'accueil' ? 'nav-compte' : 'nav-accueil'}>
          Madric
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            {localStorage.getItem('accessToken') !== null ?
             (
              <>
                <Nav.Link onClick={() => {
                  handleNavLinkClick('checkin'); props.navigateCheckin();
                }} active={activeLink === 'checkin'}>Check-in</Nav.Link>
                <Nav.Link onClick={() => {
                  handleNavLinkClick('chantiers'); props.navigateChantier();
                }} active={activeLink === 'chantiers'} >Projets</Nav.Link>
                {localStorage.getItem('admin') === '1' &&
                <Nav.Link onClick={() => {
                  handleNavLinkClick('historique'); props.navigateHistorique();
                }} active={activeLink === 'historique'} >Historique</Nav.Link>}
              </>
            ) : ( <></> )}
          </Nav>
          <Nav className="mr-auto">
            {localStorage.getItem('accessToken') === null ?
             (
             <Nav.Link onClick={() => {
               handleNavLinkClick('compte'); props.navigateLogin();
             }} active={activeLink === 'compte'}>
              Connection
             </Nav.Link>
            ) : (
            <NavDropdown title={
              <span
                className={activeLink === 'compte' ? 'nav-compte' :''}>
                Compte
              </span>
            } id="collasible-nav-dropdown">
              {localStorage.getItem('admin') === '1' &&
              <NavDropdown.Item onClick={() => {
                handleNavLinkClick('compte'); props.navigateAdministration();
              }}>Administration</NavDropdown.Item>}
              <NavDropdown.Item onClick={() => {
                handleNavLinkClick('compte'); props.handleLogout();
              }}>Se deconnecter</NavDropdown.Item>
            </NavDropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbartopView;
